var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.993,
    height: 12.125,
    viewBox: "0 0 18.993 12.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-court-2851468",
    d: "M19.687,13H1.306A.313.313,0,0,0,1,13.319V24.806a.313.313,0,0,0,.306.319h18.38a.313.313,0,0,0,.306-.319V13.319A.313.313,0,0,0,19.687,13Zm-3.063,6.7a.639.639,0,1,1,.613-.638A.626.626,0,0,1,16.623,19.7Zm-.06-1.908h0a1.275,1.275,0,0,0,0,2.54h0l2.817.587V23.21h-.919a4.151,4.151,0,0,1,0-8.3h.919v2.291Zm.987,2.1a1.291,1.291,0,0,0,0-1.65l1.83-.381v2.413Zm-7.36.738a1.61,1.61,0,0,1,0-3.126ZM10.8,17.5a1.61,1.61,0,0,1,0,3.126ZM3.757,19.062a.613.613,0,1,1,.613.638A.626.626,0,0,1,3.757,19.062Zm-.315.825-1.83.381V17.856l1.83.381a1.291,1.291,0,0,0,0,1.65Zm-1.83,1.032,2.817-.587h0a1.275,1.275,0,0,0,0-2.54h0l-2.817-.587V14.914h.919a4.151,4.151,0,0,1,0,8.3H1.613Zm0,2.929h.919a4.79,4.79,0,0,0,0-9.572H1.613v-.638H10.19v3.216a2.245,2.245,0,0,0,0,4.416v3.216H1.613Zm9.19.638V21.27a2.245,2.245,0,0,0,0-4.416V13.638H19.38v.638h-.919a4.79,4.79,0,0,0,0,9.572h.919v.638Z",
    transform: "translate(-1 -13)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourt);
export default __webpack_public_path__ + "static/media/Court.2189bf76.svg";
export { ForwardRef as ReactComponent };